// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
import ScrollspyController from "./scrollspy_controller"
import BgController from "./bg_controller"
import SwiperController from "./swiper_controller"
import VideoController from "./video_controller"

application.register("carousel", CarouselController)
application.register("scrollspy", ScrollspyController)
application.register("bg", BgController)
application.register("swiper", SwiperController)
application.register("video", VideoController)